import type { ReactNode } from 'react';

interface Props {
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmModal({
  title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel',
  destructive = true, onConfirm, onClose,
}: Props) {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-[10000]">
      <div className={`panel p-6 w-full max-w-lg border-2 ${destructive ? 'border-rose-500' : 'border-teal-500'}`}>
        <h3 className={`text-2xl font-bold mb-3 ${destructive ? 'text-rose-400' : 'text-teal-400'}`}>{title}</h3>
        <div className="text-slate-300 mb-6 text-sm leading-relaxed">{message}</div>
        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="btn-ghost">{cancelLabel}</button>
          <button onClick={onConfirm} className={destructive ? 'btn-danger' : 'btn-primary'}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
